<template>
  <div class="contentArea h-screen">
    <h4 class="mb-5">เลือกรูปแบบ Banner ที่ต้องการเผยแพร่</h4>
    <div class="flex items-center mb-3">
      <vs-radio
        class="radioitem"
        vs-name=""
        vs-value="link"
        color=" #0430AD"
        v-model="publish"
      >
        <span class="ml-2 radioText"
          >เผยเเพร่ Banner คอร์สเรียนแบบ LIVE สด</span
        >
      </vs-radio>
    </div>
    <vs-input
      class="w-full justify-end mb-5 pl-8"
      placeholder="URL Embed link"
      v-model="live_url"
    />

    <div class="flex items-center mb-5">
      <vs-radio
        class="radioitem"
        vs-name=""
        vs-value="table"
        v-model="publish"
        color=" #0430AD"
      >
        <span class="ml-2 radioText">เผยเเพร่ Banner คอร์สเรียนแบบรูปภาพ</span>
      </vs-radio>
    </div>

    <AgGrid />

    <div class="mt-5">
      <input type="checkbox" id="checkbox" v-model="countdown" />
      <label class="pl-5" for="checkbox">การตั้ง Countdown</label>
      <div class="flex items-center pl-8">
        <vs-input
          class="w-2/3 pr-5"
          placeholder="ชื่อที่ต้องการแสดง"
          v-model="countdown_name"
        />
        <v-date-picker
          mode="dateTime"
          v-model="date"
          :min-date="new Date()"
          :update-on-input="false"
          is-required
        >
          <template v-slot="{ inputEvents }">
            <vs-input :value="ChangeFormatDate" v-on="inputEvents" />
          </template>
        </v-date-picker>
      </div>

      <div class="flex justify-center mt-5">
        <button class="mb-5 share-btn" @click="SaveBanner()">
          บันทึก และเผยแพร่
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AgGrid from "../elements/ag-grid-table/AgGridTable.vue";
import aixos from "../../util/backend";
import baseUrl from "../../util/baseUrl";
import moment from "moment";
export default {
  async mounted() {
    await this.$store.dispatch("general/get_bannerTable");
    await this.$store.dispatch("general/get_countdown");
    this.$store.dispatch("general/push_pointer", "banner");
    await this.isBannerlive();
    await this.isCountdown();
  },
  components: {
    AgGrid
  },
  data() {
    return {
      publish: null,
      exp_date: null,
      live_url: null,
      date: new Date(),
      countdown: null,
      countdown_name: ""
    };
  },

  computed: {
    ...mapGetters({
      page: "general/page",
      countdown_detail: "general/countdown"
    }),

    ChangeFormatDate() {
      return moment(this.date).format("DD/MM/YYYY ,h:mm:ss a");
    }
  },
  methods: {
    async isBannerlive() {
      if (this.page.live_banner) {
        this.live_url = this.page.live_banner.url;
        console.log(this.page.live_banner.is_public);
      }
      if (this.page.live_banner && this.page.live_banner.is_public) {
        this.publish = "link";
      } else {
        this.publish = "table";
      }
    },
    isCountdown() {
      if (this.countdown_detail.end_at) {
        this.countdown_name = this.countdown_detail.name;
        this.date = this.countdown_detail.end_at;
        this.countdown_detail.is_public === true
          ? (this.countdown = true)
          : (this.countdown = false);
      } else {
        this.date = new Date();
      }
    },

    async SaveBanner() {
      let success = true;
      const BannerManage = async () => {
        if (this.publish == "link") {
          if (this.live_url) {
            await aixos.api
              .post(`${baseUrl.baseurl()}/createBanner`, {
                url: this.live_url,
                type: "live"
              })
              .then(res => {
                // if (res.status === 200) {
                //   alert("Update success.");
                // }
              })
              .catch(err => {
                console.log(err);
                success = false;
              });
          }
        } else if (this.publish == "table") {
          await aixos.api
            .put(`${baseUrl.baseurl()}/closeLiveBanner`)
            .then(res => {
              // if (res.status === 200) {
              //   alert("Update success.");
              // }
            })
            .catch(err => {
              console.log(err);
              success = false;
            });
        }
        await aixos.api
          .post(`${baseUrl.baseurl()}/createCountdown`, {
            name: this.countdown_name,
            start_at: new Date(),
            end_at: this.date,
            is_public: this.countdown
          })
          .then(res => {
            // if (res.status === 200) {
            //   alert("Update success.");
            // }
          })
          .catch(err => {
            console.log(err);
            success = false;
          });
      };
      // const CountdownManage = (status) => {
      //   aixos
      //     .post(`${baseUrl.baseurl()}/createCountdown`, {
      //       name: this.countdown_name,
      //       start_at: new Date(),
      //       end_at: this.date,
      //       is_public: status,
      //     })
      //     .then((res) => {
      //       if (res.status === 200) {
      //         alert("Update success.");
      //       }
      //     });
      // };

      await BannerManage();
      if (success) {
        this.$vs.notify({
          title: "อัพเดท Banner",
          text: "สำเร็จ",
          color: "success",
          icon: "check_box",
          position: "top-right"
        });
      } else {
        this.$vs.notify({
          title: "Error message",
          text: "อัพเดทไม่สำเร็จ",
          color: "danger",
          icon: "error",
          position: "top-right"
        });
      }
      // await CountdownManage(this.countdown);
    }
  }
};
</script>

<style lang="scss" scoped>
.radioText {
  font-family: "Kanit", sans-serif !important;
  font-size: 1rem;
  color: #434242;
  white-space: nowrap;
}
.radioitems {
  margin-top: 15px;
  background-color: pink;
}

input[type="radio"]:checked {
  background-color: #93e026;
}
</style>
